import React from "react";
import { connect } from "react-redux";
import { pushHistory as push } from "../../../browserHistory";
import * as cookieMessageActions from "../../../state/actions/cookieMessage.actions";
import events from "../../../state/actions/innerHtml.actions";
import { getLocaleState } from "../../../state/selectors/index";
import { isInternalLink, stripProtocol } from "../../../utils/link.utils";
import { translate } from "../../../utils/translate.utils";

function isEvent(href) {
  return href && href.startsWith("link://");
}

export class InnerHtmlInternal extends React.Component<any> {
  handle = e => {
    let el = e.target;
    while (el && el.nodeName !== "A") {
      el = el.parentNode;
    }

    if (!el) {
      return;
    }

    const target = el.getAttribute("target");
    const href = el.getAttribute("href");

    if (isEvent(href)) {
      e.nativeEvent.preventDefault();

      this.props.triggerEvent(href);
    } else if (isInternalLink(href) && (!target || target === "_self")) {
      e.nativeEvent.preventDefault();
      const { language, region } = this.props.locale;

      if (href.endsWith(translate(language, region, "CookiePage.url"))) {
        this.props.setCookieOpenState(false);
      }
      this.props.pushHistory(href);
    }
  };

  render() {
    const {
      html,
      pushHistory,
      locale,
      setCookieOpenState,
      triggerEvent,
      ...rest
    } = this.props;

    return (
      <div
        onClick={this.handle}
        {...rest}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }
}

const mapStateToProps = state => ({
  locale: getLocaleState(state)
});

const mapDispatchToProps = dispatch => ({
  triggerEvent: href => {
    const [command, params] = stripProtocol(href).split(":");

    if (params) {
      dispatch(events[command][params]());
    } else {
      dispatch(events[command]());
    }
  },
  setCookieOpenState: state =>
    dispatch(cookieMessageActions.setOpenState(state))
});

const InnerHtml = props => <InnerHtmlInternal pushHistory={push} {...props} />;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InnerHtml);
